import { Component, Input } from '@angular/core';
import { CalcTreatmentResponse } from '../backend-response-models/calc-interfaces.helper';
import { TranslatePipe } from '../languages/translate.pipe';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-myopia-treatments',
  standalone: true,
  imports: [TranslatePipe, DatePipe],
  templateUrl: './myopia-treatments.component.html',
  styleUrl: './myopia-treatments.component.css',
})
export class MyopiaTreatmentsComponent {
  @Input({ required: true })
  treatmentCalcResponse!: CalcTreatmentResponse;

  constructor(private translatePipe: TranslatePipe) {}
}
